// IE 2026 10 05 / ODOO-5800 (Igor, бой, «Фервекс малина саше №8» × «ТС Galaxy хранение», 2026-11, ПП #00000000065: «в форме расшифровки показано несколько статусов,
// хотя в движения за 2026-11 берутся только … ВПути»; проверка dev02: до ответа паспорта форма 0,8–1,3 с показывала прежний бейдж «Отказ»).
// Документы блока DOCUMENTS формы ячейки — чистые функции (тест tests/unit/cellDocs.test.mjs):
//  · статусы документа по строкам источника отчёта, спустившимся в ЭТУ ячейку, — спутник ячейки doc_st {id: [статус, …]} (бэк doc_links); раньше форма знала один статус на
//    документ на весь отчёт (record._doc.doc_links.docs[id][1] — первая попавшаяся строка источника);
//  · пока паспорт ячейки не ответил, бейдж статуса не показывается (заглушка): предварительный статус мог быть заведомо неверным; ответа с документами нет — предварительный
//    статус возвращается. Выключатель fe.cellForm.docStatusWait (false — прежний вид: предварительный бейдж сразу);
//  · подсказка бейджа — «<сырой статус> · <название статуса расчёта>» (status.hint бэка).
export const DOC_STATUS_WAIT_FLAG = 'fe.cellForm.docStatusWait'

// {id: [статус, …]} документов ids по спутнику ячейки doc_st; ячейка без спутника (агрегированный источник, прежний бэк) — {}
export function cellDocs_cellStatuses(cell, ids) {
    const src = cell && typeof cell === 'object' ? cell.doc_st : null, out = {}
    if (!src || typeof src !== 'object') return out
    for (const id of (Array.isArray(ids) ? ids : [])) {
        const v = src[String(id)]
        const lst = (Array.isArray(v) ? v : []).map(x => String(x ?? '').trim()).filter(Boolean)
        if (lst.length) out[String(id)] = lst
    }
    return out
}

// предварительный статус документа (до ответа паспорта): первый статус строк ЭТОЙ ячейки, иначе статус строки источника на весь отчёт (docs[id] = [сегмент, статус])
export function cellDocs_preStatus(id, docsOfReport, cellStatuses) {
    const sid = String(id), own = cellStatuses && cellStatuses[sid], x = docsOfReport && docsOfReport[sid]
    const st = (Array.isArray(own) && own[0]) || (Array.isArray(x) && x[1]) || ''
    return st ? { id: String(st), text: String(st), css: '' } : null
}

// паспорт в пути: бейдж статуса скрыт (status = null, status_wait), предварительный статус — в status_pre
export function cellDocs_wait(docs, loading, on) {
    if (!Array.isArray(docs) || !loading || on === false) return docs
    return docs.map(d => (d && typeof d === 'object') ? { ...d, status_pre: d.status || null, status: null, status_wait: true } : d)
}

// паспорт ответил без документов (прежний бэк, ошибка docs): предварительный статус возвращается
export function cellDocs_restore(docs) {
    if (!Array.isArray(docs) || !docs.some(d => d && d.status_wait)) return docs
    return docs.map(d => {
        if (!d || !d.status_wait) return d
        const { status_pre, status_wait, ...rest } = d   // eslint-disable-line no-unused-vars
        return { ...rest, status: status_pre || null }
    })
}

// подсказка бейджа статуса: hint бэка («ВПути · Confirmed»), без него — fallback («Document status»)
export function cellDocs_statusHint(d, fallback) {
    const h = d && d.status && typeof d.status.hint === 'string' ? d.status.hint.trim() : ''
    return h || fallback || ''
}

// IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: документы без ссылки — количество и статус в блоке документов)
// Бэк (PR #521 / #522) кладёт в docs паспорта, кроме документов ячейки, сводные строки «Without a document reference» (id 'nodoc:<тип>:<статус>', d.nodoc, link null)
// и строки регистра 1С (id 'register:…'). Две правки отображения количеств:
//  · строка без документа берёт своё qty бэка, когда количества документов пришли спутником ячейки doc_qty (в нём только документы, id nodoc нет — qty терялось);
//  · строки регистра не входят в сумму проверки «сумма количеств ≤ значения ячейки»: регистр догружается позже расчёта (8 879 против 8 272) — иначе форма прятала
//    ВСЕ количества. Выключатель fe.ux.sameDocQtyCheckSkipRegister (false — прежняя проверка по всем строкам).
export const SAMEDOC_SKIP_REGISTER_FLAG = 'fe.ux.sameDocQtyCheckSkipRegister'

export function cellDocs_isRegister(id) { return /^register:/.test(String(id ?? '')) }

// количества документов ячейки {id: число}, проверенные по значению ячейки v: сумма (без строк регистра при skipRegister) больше |v| — null (строка-группа видит лишнее);
// знак — как у значения ячейки. Нет ни одного числа — null
export function cellDocs_qtyCheck(qtyOf, v, skipRegister) {
    if (!qtyOf || typeof qtyOf !== 'object') return null
    const ids = Object.keys(qtyOf).filter(k => qtyOf[k] != null && isFinite(+qtyOf[k])); if (!ids.length) return null
    let sum = 0, all = 0; for (const k of ids) { all += +qtyOf[k]; if (!(skipRegister && cellDocs_isRegister(k))) sum += +qtyOf[k] }
    const num = typeof v === 'number' && isFinite(v)
    const flip = num && all * v < 0 ? -1 : 1   // знак — по всем строкам (как прежде)
    if (num && Math.abs(sum) > Math.abs(v) + 0.5) return null
    const out = {}; for (const k of ids) out[k] = flip * (+qtyOf[k])
    return out
}

// количество строки блока DOCUMENTS: проверенное (Q[id]), иначе у строки без документа (d.nodoc) — qty бэка (сумма движений ячейки без ссылки), иначе null
// IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: количества строк регистра при спутнике doc_qty): строки регистра 1С (register:*) — как nodoc, своё qty бэка:
// спутник doc_qty знает только документы ячейки, и при нём количества контрагентов регистра терялись (00a6279b: 944 + 556 видны, 84 / 66 / 22 … — нет); on === false
// (fe.cellForm.docQty выкл.) — без запасных количеств; register === false (fe.ux.sameDocQtyCheckSkipRegister выкл., прежняя проверка) — строки регистра без запасного qty
export function cellDocs_rowQty(d, Q, opt) {
    const on = !opt || opt.on !== false, reg = !opt || opt.register !== false   // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: количества строк регистра при спутнике doc_qty)
    const id = String(d?.id ?? ''), q = Q && Q[id]
    if (q != null) return q
    if (!on) return null   // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: количества строк регистра при спутнике doc_qty)
    return (d && (d.nodoc || (reg && cellDocs_isRegister(id))) && d.qty != null && isFinite(+d.qty)) ? +d.qty : null   // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: количества строк регистра при спутнике doc_qty)
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
// Источник количеств строк блока DOCUMENTS: cellQ — проверенный спутник ячейки doc_qty (строки отчёта), passQ — проверенные qty бэка (docs[].qty). Прежде спутник был первым.
// Паспорт отобрал движения ячейки отбором полосы строки (block_where бэка применён, passportFirst) — первыми qty бэка: спутник ячейки строк полосы не знает (у PO-U02
// декабря «⚠ Uncovered» doc_qty спутника пустой, а строки nodoc / MOQ top-up в нём не бывают). Проверка qty бэка не прошла — спутник, как прежде.
export function cellDocs_qtySource(cellQ, passQ, passportFirst) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
    return (passportFirst ? (passQ || cellQ) : (cellQ || passQ)) || {}
}
